var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[_c('v-alert',{staticClass:"flash-container",style:(_vm.transitionStyle),attrs:{"type":_vm.options.type}},[_vm._v(" "+_vm._s(_vm.options.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }